/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Wizard_Meet_IntroInputs */



/**
* | output |
* | --- |
* | "An agent is like a colleague you brief once. From then on it works when you ask, on a schedule or inside a chat, and it checks with you before doing anything..." |
*
* @param {Agent_Wizard_Meet_IntroInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_wizard_meet_intro = /** @type {((inputs?: Agent_Wizard_Meet_IntroInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Wizard_Meet_IntroInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Agent ist wie ein Kollege, den Sie einmal einweisen. Danach arbeitet er, wann Sie möchten, nach Zeitplan oder in einem Chat, und fragt Sie, bevor er etwas außerhalb von oneAI tut.")
	return /** @type {LocalizedString} */ ("An agent is like a colleague you brief once. From then on it works when you ask, on a schedule or inside a chat, and it checks with you before doing anything outside oneAI.")
});